import { Box, Typography } from "@mui/material";

export const StepTitle = ({ title, subtitle }) => {
  return (
    <Box
      sx={{
        pr: 4,
        width: "100%",
        display: "flex",
        overflow: "hidden",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mb: 2,
        textAlign: "center",
      }}
    >
      <Typography
        fontWeight={800}
        sx={{
          fontSize: 32,
          textTransform: "uppercase",
          background: "linear-gradient(180deg, #222 0%, #555 100%)",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: "1px",
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            fontSize: 18,
            fontWeight: 400,
            maxWidth: 600,
            lineHeight: 1.5,
            mt: 1,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
